export const authMixin = {
  methods: {
    auth_onAuth(access_token, loggedInData, _referer) {
      let referer = _referer ? _referer : ''
      //call action onAuth in store
      let dataToDispatch = {
        access_token: access_token,
        loggedInData: loggedInData
      }
      this.$store.dispatch('onAuth', dataToDispatch).then(() => {
        //go to dashboard for agent type
        console.log('auth_onAuth', referer, dataToDispatch.loggedInData.agentData.type)
        switch (referer) {
          case 'logoutAs':
            //go to admin page
            this.$router.replace({ name: 'admin'})
          break
          default:
            switch (dataToDispatch.loggedInData.agentData.type) {
              case 'company':
                this.$router.replace({ name: 'company-dashboard'})
              break;
              case 'driver':
                this.$router.replace({ name: 'driver-dashboard'})
              break;
              default:
                console.log("Unknown agent type", dataToDispatch.loggedInData.agentData.type)
            }
        }
      })
    }
  }
}
